<kendo-label>
    <span [ngClass]="{'filterType': filterType == 'value'}" (click)="filterTypeChange('condition')">Filter by Condition
    </span>|
    <span [ngClass]="{'filterType': filterType == 'condition'}" (click)="filterTypeChange('value')">Filter by
        Value</span>
</kendo-label>

<div id="customGridFilter" class="mt-10">
    <div *ngIf="filterType == 'value'">
        <input class="k-textbox k-input k-rounded-md" [(ngModel)]="valueFilterText" placeholder="Search" (input)="onInput($event)" />

        <label class="select-all-label mt-5">
            <input type="checkbox" [(ngModel)]="allSelected" (change)="toggleSelectAll()" class="custom-checkbox"
                [ngClass]="{'custom-checkbox-intermediate': value.length > 0 && value.length != currentData.length}" />
            Select All
        </label>

        <ul class="mt-5">
            <li #itemElement *ngFor="let item of currentData | slice:0:250; let i = index; trackBy: trackByItem"
                (click)="onSelectionChange(valueAccessor(item), itemElement)"
                [ngClass]="{'k-selected': isItemSelected(item)}">
                <input type="checkbox" #notification kendoCheckBox [checked]="isItemSelected(item)" />
                <kendo-label *ngIf="filterDataType == 'date'" class="k-checkbox-label" [for]="notification"
                    [text]="textAccessor(item) | safeString: 'dd-MM-yyyy'"></kendo-label>
                <kendo-label *ngIf="filterDataType != 'date'" class="k-checkbox-label" [for]="notification"
                    [text]="textAccessor(item)"></kendo-label>
            </li>
        </ul>
    </div>

    <div *ngIf="filterType == 'condition'">
        <kendo-grid-string-filter-menu [column]="column" [filter]="conditionFilter"
            [filterService]="conditionFilterService" *ngIf="filterDataType == 'text'">
        </kendo-grid-string-filter-menu>

        <kendo-grid-numeric-filter-menu [decimals]="0" [format]="'no'" [column]="column" [filter]="conditionFilter"
            [filterService]="conditionFilterService" *ngIf="filterDataType == 'numeric'">
        </kendo-grid-numeric-filter-menu>

        <kendo-grid-date-filter-menu [column]="column" [filter]="conditionFilter"
            [filterService]="conditionFilterService" format="dd-MM-yyyy" *ngIf="filterDataType == 'date'">
        </kendo-grid-date-filter-menu>

        <kendo-grid-boolean-filter-menu [column]="column" [filter]="conditionFilter"
            [filterService]="conditionFilterService" *ngIf="filterDataType == 'boolean'">
        </kendo-grid-boolean-filter-menu>
    </div>

    <div class="filterButtonSection mt-10">
        <button kendoButton [disabled]="filterType == 'value' && value.length == 0" (click)="onConditionFilterChange()">Apply</button>
        <button kendoButton (click)="cancelFilter()">Cancel</button>
        <button kendoButton (click)="resetFilters()">Clear</button>
    </div>
</div>